import { RequestType } from "./requestType";

export function createActions<T, R, S>(actionType: RequestType) {
    return {
        request: function request(args: R): T {
            // @ts-ignore
            return {
                type: actionType.request,
                payload: args,
            };
        },
        success: function success(args: S): T {
            // @ts-ignore
            return {
                type: actionType.success,
                payload: args,
            };
        },
        failure: function failure(error?: any): T {
            // @ts-ignore
            return {
                type: actionType.failure,
                payload: error,
            };
        },
    }
};
